require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./management-of-biotech-medtech-pharma-ventures-cas-2-4-1-0.json") })
        }
      }, "path---management-of-biotech-medtech-pharma-ventures-cas-2-4-1-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---management-of-biotech-medtech-pharma-ventures-cas-2-4-1-0!./.cache/json/management-of-biotech-medtech-pharma-ventures-cas-2-4-1-0.json
// module id = 485
// module chunks = 231608221292675